module.exports = __webpack_public_path__ + "img/new.b747a9c0.svg";